import * as actiontypes from '../../constants/actionType';
// import { setTrayID } from './appStateAction';

export function showModalSetTrayID(type, param) {
  return (dispatch) => {
    // dispatch(setTrayID(1));
    dispatch({type: actiontypes.SHOW_MODAL_SET_TRAY_ID, data: type, param});
  };
}

export function hideModalSetTrayID() {
  return {type: actiontypes.HIDE_MODAL_SET_TRAY_ID};
}

export function resetModalSetTrayID() {
  return {type: actiontypes.RESET_MODAL_SET_TRAY_ID};
}
